module.exports = __webpack_public_path__ + "img/demo-coupon.5321c4f3.jpg";